module.exports = [
  /* ce cas inclus une commande annulee */
  {
    code: 0,
    name: 'consumer-removed',
    title: 'Supprimé par conso',
    description: 'Le consommateur a choisi de supprimer'
  },
  {
    name: 'missing-preparation',
    title: 'Quantité manquant preparation',
    description: 'Le produit manquait lors de la preparation',
    code: 1
  },
  {
    name: 'missing-distribution',
    title: 'Quantité manquant distribution',
    description: 'Le produit manquait lors de la distribution',
    code: 2
  },
  {
    name: 'missing-sav',
    title: 'Quantité déclarée manquant par service client',
    description: 'Le produit a été déclaré manquant par la service client',
    code: 3
  },
  {
    name: 'missing-producer',
    title: 'Le producteur nous a signalé que le produit ne sera pas livré',
    description: 'Le produit a été déclaré manquant par la service client',
    code: 4
  }
];